import { render, staticRenderFns } from "./modalIframe.vue?vue&type=template&id=4fcefb91&scoped=true"
import script from "./modalIframe.vue?vue&type=script&lang=js"
export * from "./modalIframe.vue?vue&type=script&lang=js"
import style0 from "./modalIframe.vue?vue&type=style&index=0&id=4fcefb91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcefb91",
  null
  
)

export default component.exports